import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { LanguageModal } from "./LanguageModal";
import { useDeleteUserProfileSectionItem } from "Constant/apiHooks";
import { VIEW_PROFILE_SECTIONS } from "Constant/constants";

export const Languages = ({
  languageList,
  fetchData,
  isCurrentUserProfile,
}) => {
  const { t } = useTranslation();

  const { deleteUserProfileSectionItem } = useDeleteUserProfileSectionItem();

  const [languageModal, setShowLanguageModal] = useState(false);
  const [selecrtedLanguage, setSelectedLanguage] = useState(null);

  const toggleLanguageModal = (language) => {
    setShowLanguageModal((prev) => !prev);
    if (language) {
      setSelectedLanguage(language);
    } else {
      setSelectedLanguage(null);
    }
  };

  const handleDeleteLanguage = async (gid) => {
    try {
      const payload = {
        key: VIEW_PROFILE_SECTIONS.languages,
        [VIEW_PROFILE_SECTIONS.languages]: {
          gid,
        },
      };
      await deleteUserProfileSectionItem(payload);
      fetchData();
    } catch {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  return (
    <>
      <div className="p-4 rounded-lg border border-grey-200 bg-white">
        <div className="d-flex flex-wrap justify-content-between align-items-center column-gap-3 row-gap-2 mb-3">
          <h4 className="mb-0 text-md font-semibold text-grey-800">
            {t("auth.viewProfile.languages")}
          </h4>
          {isCurrentUserProfile && (
            <div className="d-flex align-items-center gap-1">
              <button
                type="button"
                className="btn btn-gray-light font-medium rounded-lg d-inline-flex align-items-center gap-1"
                onClick={() => toggleLanguageModal()}
              >
                <i className="bx bx-plus"></i>{" "}
                {t("auth.viewProfile.addLanguage")}
              </button>
            </div>
          )}
        </div>
        <ul className="resume-uploaded-list list-unstyled mt-3 mb-0 d-flex flex-column justify-content-center row-gap-3">
          {languageList && languageList.length > 0 ? (
            languageList.map((language, idx) => (
              <li key={idx.toString()}>
                <div className="d-flex flex-column row-gap-0">
                  <div className="d-flex gap-3">
                    <div className="d-flex flex-column row-gap-0">
                      <h5 className="mb-0 text-base font-semibold text-grey-800">
                        {language.name}
                      </h5>
                      <span>{language.proficiency}</span>
                    </div>
                    {isCurrentUserProfile && (
                      <div className="ms-auto d-flex align-items-center gap-3">
                        <Button
                          variant="link"
                          className="p-0 text-base text-grey-600 text-decoration-none"
                          onClick={() => toggleLanguageModal(language)}
                        >
                          <i className="bx bx-pencil"></i>
                        </Button>
                        <Button
                          variant="link"
                          className="p-0 text-base text-grey-600 text-decoration-none"
                          onClick={() => handleDeleteLanguage(language.gid)}
                        >
                          <i className="bx bx-trash"></i>
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </li>
            ))
          ) : (
            <li>
              <div className="">
                <span className="text-grey-400">
                  {t("auth.viewProfile.noLanguage")}
                </span>
              </div>
            </li>
          )}
        </ul>
      </div>

      {languageModal && (
        <LanguageModal
          show={languageModal}
          languageData={selecrtedLanguage}
          toggle={toggleLanguageModal}
          fetchData={fetchData}
        />
      )}
    </>
  );
};
